<template>
  <section :id="titleToId(title)" :class="{ gradient: gradient }">
    <div class="container">
      <div class="row">
        <div class="content">
          <h2 class="title">{{ title }}</h2>
          <div class="text">
            <slot></slot>
          </div>
        </div>
        <div v-if="image" class="image">
          <img :src="image" :alt="title" loading="lazy" />
        </div>
      </div>
      <div class="row info">
        <div v-if="employees" class="col employees">
          <a
            v-for="employee in employees"
            class="employee"
            :href="`/faam/team/#${employee.toLowerCase()}`"
            daa
            :key="employee"
          >
            <img :src="`/assets/img/team/${employee}_s.jpg`" :alt="employee" />
          </a>
        </div>
        <div v-if="$slots.sources" class="col extra-info">
          <h3>Websites en andere info</h3>
          <slot name="sources"></slot>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { titleToId } from "@/utilities.js";

export default {
  name: "complaint",
  props: {
    title: {
      type: String,
      required: true,
    },
    image: {
      type: String,
      required: false,
    },
    employees: {
      type: Array,
      required: false,
    },
    gradient: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  methods: {
    titleToId(title) {
      return titleToId(title);
    },
  },
};
</script>

<style lang="less">
section {
  &.gradient {
    background: linear-gradient(#00a19988, #00a19900);
  }

  .container {
    display: flex;
    flex-direction: column;

    .row {
      display: flex;
      justify-content: space-between;

      .content {
        display: flex;
        flex-direction: column;
        text-align: left;
        .text {
          display: flex;
          flex-direction: column;
          flex-grow: 1;
          justify-content: center;
        }
      }

      .image {
        display: flex;
        justify-content: center;
        height: fit-content;
        max-width: 28%;
        margin-left: 25px;
        img {
          width: 100%;
          max-width: 100%;
          border-radius: 25px;
        }
      }

      .col {
        width: 50%;
        &.employees {
          display: flex;
          flex-wrap: wrap;
          &:has(> .employee:hover) > .employee:not(:hover) {
            filter: grayscale(100%);
          }
          .employee {
            display: flex;
            height: 100px;
            min-height: 100px;
            width: 100px;
            min-width: 100px;
            margin-right: 25px;
            border-radius: 100%;
            overflow: hidden;
            transition-duration: 0.7s;
            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
              object-position: top;
              transform: scale(1.5);
            }
          }
        }
      }
    }
  }
}

@media (max-width: 768px) {
  section {
    .container {
      .row {
        flex-direction: column;
        .content {
          .text {
            margin-top: 25px;
          }
        }
        .image {
          margin-left: 0;
          margin-top: 25px;
          max-width: 100%;
          img {
            border-radius: 25px;
          }
        }
        .col {
          width: 100%;
          &.employees {
            gap: 25px;
            justify-content: space-evenly;
            .employee {
              margin-right: 0;
              // margin-bottom: 25px;
            }
          }
        }
      }
    }
  }
}
</style>
